<template>
    <div>
        <BaseModalWrapper size="l" :show="showAd" @close="showAd = false">
            <template #body>
                <div
                    class="d-flex align-items-center nordic-championships-campaign-container rin-nordic-championships-campaing-wrapper">
                    <div class="p-4">
                        <router-link to="/en/tournament/47618/nordic-team-championships-drammen-norway">
                            <img class="img-fluid"
                                src="https://cdn.rankedin.com/images/static/campaign/nordic-championships-campaign.jpeg"
                                alt="nordic-championships campaign image" />
                        </router-link>
                    </div>
                </div>
            </template>
        </BaseModalWrapper>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseModalWrapper from '@/components/rin_new_design/components/base/modals/BaseModalWrapper';


const nordicChampionshipsCampaignSettings = {
    name: 'NordicChampionshipsCampaign',
    async checkAudienceAsync(params) {
        var isLoggedIn = params.store.getters.layout.player.isAuthenticated;
        var sport = 0;

        if (isLoggedIn) {
            sport = params.store.getters.layout.player.sport;
        }
        else {
            sport = params.store.getters.layout.page.sport;
        }

        if (!params.store.getters.layout.isEmbed && sport === params.store.getters.nomenclatures.SportsArray.Padel) return Promise.resolve(true);

        return Promise.resolve(false);
    }
};
export { nordicChampionshipsCampaignSettings };

export default {
    name: 'NordicChampionshipsCampaign',
    props: {},
    data() {
        return {
            showAd: true,
        }
    },
    components: {
        BaseModalWrapper,
    },
    mounted() {

    },
    computed: {
        ...mapGetters(['translations', 'layout', 'nomenclatures']),

    },
    methods: {

    }
}
</script>

<style scoped>
.nordic-championships-campaign-container {
    justify-content: center;
}
</style>